import styled from 'styled-components'

export const RhinoLogo = styled.img`
  max-height: 24px;
`
